export function getNameInitials(name?: string | null) {
  if (!name) {
    return null;
  }

  const [first = "", last = ""] =
    name?.replace(/\s\s+/g, " ").trim().split(" ") ?? [];
  const result = first ? `${first[0]}${last[0] || ""}`.toUpperCase() : null;

  return result;
}
